module.exports = __webpack_public_path__ + "img/feature_project.11dc782b.png";